// Cloudflare still validates every token, action, hostname and expiry on the server.
// This handoff only carries a single-use token between pages in the same tab.
export const verificationKey = "silverdrop.verification.v1";
export function readVerification(storage: Pick<Storage, "getItem" | "removeItem">, action: string, account: string | null, now = Date.now()): string {
  try {
    const key = `${verificationKey}.${action}`;
    const raw = storage.getItem(key);
    if (!raw || !account) return "";
    const value = JSON.parse(raw) as { token?: unknown; account?: unknown; expires?: unknown };
    return value.account === account && typeof value.expires === "number" && value.expires > now && typeof value.token === "string" ? value.token : "";
  } catch { return ""; }
}

export function consumeVerification(storage: Pick<Storage, "getItem" | "removeItem">, action: string, account: string | null, now = Date.now()): string {
  const value = readVerification(storage, action, account, now);
  storage.removeItem(`${verificationKey}.${action}`);
  return value;
}
